const o = ["#FFBE5E"], _ = [...o, "#EC2E04"], t = [..._, "#B61661"], c = [..._, "#B9FC1D", "#B9FC1D"];
export {
  o as POI_4_TA1,
  _ as POI_4_TA2,
  t as POI_4_TA3,
  c as POI_4_TA4
};
//# sourceMappingURL=index.es5581.js.map
